import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import CoreAdvantagesContent from './components/CoreAdvantagesContent';

export default function CoreAdvantagesPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '核心優勢｜天然原料・三贏理念・整合服務・少量訂單｜康永生技',
    description: '康永生技四大核心優勢：堅持天然原料、創造三贏、整合專業服務與少量訂單接受，幫助新品牌從零開始建立保健食品品牌。',
    keywords: '核心優勢,天然原料,三贏理念,整合服務,少量訂單,康永優勢',
    lang: 'zh-TW',
    canonicalPath: '/about/core-advantages',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="核心優勢｜天然原料・三贏理念・整合服務・少量訂單｜康永生技" pageDescription="康永生技四大核心優勢：堅持天然原料、創造三贏、整合專業服務與少量訂單接受，幫助新品牌從零開始建立保健食品品牌。" pageUrl={`${siteUrl}/about/core-advantages`} />
      <CoreAdvantagesContent />
    </Layout>
  );
}